export const COLOR_CODES: string[] = [
    // '#EF5350',
    // '#FF5252',
    // '#EC407A',
    // '#FF4081',
    // '#AB47BC',
    // '#E040FB',
    // '#673AB7',
    // '#7C4DFF',
    // '#3F51B5',
    // '#3D5AFE',
    // '#1976D2',
    // '#2962FF',
    // '#0277BD',
    // '#01579B',
    // '#00796B',
    // '#1DE9B6',
    // '#4CAF50',
    // '#00C853',
    // '#9CCC65',
    // '#64DD17',
    // '#AEEA00',
    // '#D4E157',
    // '#F9A825',
    // '#FFD600',
    // '#FFA726',
    // '#FFAB40',
    // '#9E9E9E',
    // '#78909C',
    // '#607D8B'

    // '#ebbebe',
    // '#beebdd',
    // '#d2ebbe',
    // '#cabeeb',
    // '#bee5eb',
    // '#e7beeb',
    // '#ebc6be',
    // '#ccbeeb',
    // '#becaeb'

   '#589BE9',
   '#EF7852',
   '#DF4E76',
   '#69C8DE',
   '#7AC36D',
   '#7C5BC2',
   '#4F5DC6',
   '#E7C343',
   '#9BC04B',
   '#BB592C'
];
export const STAGE_COLOR_CODES:string[]=[
'#e3efff',
'#fde0d3',
'#e7f0d4',
'#ede6fc',
'#faedd8',
// '#ffffff',
'#ede6fc',
// '#e3efff',
'#e3e9ee',
"black"

// '#f3a119',
// '#82b01f',
// '#6e7491',
// '#744bd1',
// '#2080f6'
]
export const FONT_COL_CODES: string[] = [
    "#2080f6",
    "#e7733e",
    "#82b01f",
    '#744bd1',
     // "bfcbe1",
     '#f3a119',
    // '#2080f6',
    '##262a44',
    'WHITE',
];

export const ClientListEntityBgColorCode:string[]=[
"rgba(191, 203, 225, 0.6)",
"#fde0d3",
"#e7f0d4",
"#e7ebef",
"#ede6fc",
"#e3efff",
"#faedd8",
"#e0e7ff"
]
export const ClientListEntityColorCode:string[]=[
"#2d8589",
"#e7733e",
"#82b01f",
"#6e7491",
"#744bd1",
"#2080f6",
"#f3a119",
"#3358dd"
]